import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Users, Home, LogOut, Bell } from 'lucide-react';
import NotificationSettings from './NotificationSettings';

const Navbar = ({ user, onLogout }) => {
  const location = useLocation();
  const [showNotifications, setShowNotifications] = useState(false);

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/friends', icon: Users, label: 'Friends' }
  ];

  return (
    <nav className="bg-white/10 backdrop-blur-md border-b border-white/20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/logo-compressed.png" 
              alt="BodyDouble Logo" 
              className="max-w-11 max-h-11 w-auto h-auto"
            />
          </Link>

          {/* Navigation Links */}
          <div className="flex items-center space-x-6">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center space-x-1 px-3 py-2 rounded-lg transition-all duration-200 ${
                    isActive 
                      ? 'bg-white/20 text-white' 
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="font-medium">{item.label}</span>
                </Link>
              );
            })}
          </div>

          {/* User Menu */}
          <div className="flex items-center space-x-4">
            <button
              onClick={() => setShowNotifications(true)}
              className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-all duration-200"
              title="Notification settings"
              aria-label="Notification settings"
            >
              <Bell className="w-4 h-4" />
            </button>
            <div className="text-white/90">
              <span className="font-medium">{user?.name}</span>
            </div>
            <button
              onClick={onLogout}
              className="flex items-center space-x-1 px-3 py-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-all duration-200"
            >
              <LogOut className="w-4 h-4" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>

      {showNotifications && user && (
        <NotificationSettings user={user} onClose={() => setShowNotifications(false)} />
      )}
    </nav>
  );
};

export default Navbar;
